<ion-app>
    <ion-router-outlet id="main-content"></ion-router-outlet>

    @if (showDebugInfo) {
        <app-memory-usage-div></app-memory-usage-div>
    }
</ion-app>
